import React, { useState } from 'react';
import { Link } from 'react-router-dom';

export default function PublicHeader() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setMobileMenuOpen(false);
  };

  return (
    <header className="bg-pure-white shadow-subtle sticky top-0 z-fixed">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <Link
            to="/"
            className="flex items-center gap-2 sm:gap-3 hover:opacity-80 transition-opacity duration-200"
          >
            <img
              src="/logo.png"
              alt="CampusMeds logo"
              className="h-8 w-auto object-contain"
            />
            <span className="text-title-lg text-gray-900 font-inter">
              CampusMeds
            </span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-6">
            <Link
              to="/about"
              className="text-supporting text-text-secondary hover:text-gray-900 transition-colors duration-200"
            >
              About
            </Link>
            <Link
              to="/contact"
              className="text-supporting text-text-secondary hover:text-gray-900 transition-colors duration-200"
            >
              Contact
            </Link>
            <Link
              to="/how-it-works"
              className="text-supporting text-text-secondary hover:text-gray-900 transition-colors duration-200"
            >
              How It Works
            </Link>
            <a
              href="https://blog.campusmeds.inpstockrx.com"
              className="text-supporting text-text-secondary hover:text-gray-900 transition-colors duration-200"
            >
              Blog
            </a>
            <Link
              to="/admin"
              className="text-supporting text-trust-blue hover:text-trust-blue/80 bg-pure-white px-4 py-2 rounded-md border border-border-light hover:border-trust-blue transition-all duration-200 whitespace-nowrap"
            >
              Staff Login
            </Link>
          </nav>

          {/* Mobile Hamburger Button */}
          <button
            onClick={toggleMobileMenu}
            className="md:hidden p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100 transition-colors duration-200"
            aria-label="Toggle menu"
            aria-expanded={mobileMenuOpen}
          >
            {mobileMenuOpen ? (
              // Close Icon (X)
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            ) : (
              // Hamburger Icon
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            )}
          </button>
        </div>

        {/* Mobile Navigation Menu */}
        <div
          className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out ${
            mobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
          }`}
        >
          <nav className="py-4 space-y-2 border-t border-gray-100">
            <Link
              to="/about"
              onClick={closeMobileMenu}
              className="block px-4 py-3 text-base text-text-secondary hover:text-gray-900 hover:bg-gray-50 rounded-md transition-colors duration-200"
            >
              About
            </Link>
            <Link
              to="/contact"
              onClick={closeMobileMenu}
              className="block px-4 py-3 text-base text-text-secondary hover:text-gray-900 hover:bg-gray-50 rounded-md transition-colors duration-200"
            >
              Contact
            </Link>
            <Link
              to="/how-it-works"
              onClick={closeMobileMenu}
              className="block px-4 py-3 text-base text-text-secondary hover:text-gray-900 hover:bg-gray-50 rounded-md transition-colors duration-200"
            >
              How It Works
            </Link>
            <a
              href="https://blog.campusmeds.inpstockrx.com"
              onClick={closeMobileMenu}
              className="block px-4 py-3 text-base text-text-secondary hover:text-gray-900 hover:bg-gray-50 rounded-md transition-colors duration-200"
            >
              Blog
            </a>
            <Link
              to="/admin"
              onClick={closeMobileMenu}
              className="block px-4 py-3 text-base text-trust-blue hover:text-trust-blue/80 bg-pure-white border border-border-light hover:border-trust-blue rounded-md transition-all duration-200"
            >
              Staff Login
            </Link>
          </nav>
        </div>
      </div>
    </header>
  );
}
